export const usersAPIUrls = {
  get: '/users/fetchAll',
  create: '/users/create',
  update: '/users/update',
  delete: '/users/delete',
  getUser: '/users/fetch',
  getRecentActivity: '/recent-activity/{id}',
  fetchAll: '/users/fetchAll',
  uploadCSV: '/users/import-csv',
} as const;
